<div class="mt-16">
  <div class="flex flex-col gap-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-[24px] font-bold">Mis adhesiones recibidas</h2>
        <span class="text-[16px] text-neutral-dark">
          Peticiones recibidas desde otra unidad administrativa solicitando la adhesión a protocolos de acceso a datos
          ofrecidos como cedente.
        </span>
      </div>
      <app-buttons
        [label]="'Nueva adhesión'"
        icon="pi pi-plus"
        [classes]="'bg-primary-base text-white'"
        [routerLink]="'/nueva-adhesion'" />
    </div>
    <app-tabs
      class="mt-4"
      [type]="'tabsWithURL'"
      [items]="tabsItems()" />
    <app-search-bar
      [showExternalButton]="true"
      [placeholder]="'Buscar adhesiones por identificador, nombre, procedimiento, código de organismo o protocolo.'"
      (search)="handleSearch($event)" />
    <div class="flex flex-col justify-end gap-2">
      <app-filters
        class="w-[100%]"
        [title]="'Buscar por filtros'"
        (applyFilters)="handleApplyFilters($event)"
        [filtersAdvanced]="advancedFilters"
        [containerClass]="'flex flex-row items-end gap-3 flex-wrap'" />
      <div class="flex min-w-[1200px] justify-between items-end">
        <h3 class="text-[18px] font-bold">Total de resultados: {{ totalResults() }} resultados</h3>
        <app-dropdown
          [options]="orderby.options ?? []"
          [label]="orderby.label ?? ''"
          [icon]="orderby.icon ?? ''"
          [hiddenArrow]="true"
          [classes]="orderby.classes ?? ''"
          (select)="onDropdownChange($event)" />
      </div>
    </div>
  </div>
  <div
    class="flex flex-col justify-center items-center my-4"
    *ngFor="let accession of accessions()">
    <app-accession-card
      [approvedActions]="getApprovedActions(accession)"
      [title]="accession.title"
      [state]="accession.state"
      [rpts]="accession.rpts"
      [creationDate]="getCreateDate(accession)"
      [detailUrl]="`/mis-adhesiones/detalles/${accession.id}`"
      [id]="getAccessionId(accession)"
      [query]="'received'"
      [validatedTime]="getValidatedTime(accession)"
      [service]="`${accession.serviceCode} - ${accession.service}`" />
  </div>
  <app-pagination
    [totalItems]="totalResults()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
<p-confirmdialog />
